export default "__VITE_ASSET__CvI8aOMK__"